import { render, staticRenderFns } from "./collection_modal.vue?vue&type=template&id=4a5d5576&"
import script from "./collection_modal.vue?vue&type=script&lang=js&"
export * from "./collection_modal.vue?vue&type=script&lang=js&"
import style0 from "./collection_modal.vue?vue&type=style&index=0&id=4a5d5576&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports